module.exports = __webpack_public_path__ + "img/os-preference.a187e5e7.svg";